import { render, staticRenderFns } from "./ChatSuggestionsComponent.vue?vue&type=template&id=35d92e1e&scoped=true"
import script from "./ChatSuggestionsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSuggestionsComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatSuggestionsComponent.vue?vue&type=style&index=0&id=35d92e1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d92e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d92e1e')) {
      api.createRecord('35d92e1e', component.options)
    } else {
      api.reload('35d92e1e', component.options)
    }
    module.hot.accept("./ChatSuggestionsComponent.vue?vue&type=template&id=35d92e1e&scoped=true", function () {
      api.rerender('35d92e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatSuggestionsComponent.vue"
export default component.exports